import camelCase           from 'lodash/camelCase'
import ScrollToErrorMixin  from '../../../../support/scroll_to_error_mixin'
import WizardController    from '../../../wizard_controller'
import mixin               from '../../../../support/mixin'

export default class extends mixin(WizardController, ScrollToErrorMixin) {

  static targets = [
    'diabetesGeneticDefectsAndSyndromes',
    'diabetesDetails',
    'diagnosedDate',
    'defaultOther',
    'gravidityDetails',
    'lada',
    'mellitusPregnancy',
    'mody',
    'neonatalDiabetes',
    'otherMellitus',
    'pregnancyDetails',
    'preselectedE13',
    'secondaryDiabetes',
    'selectDiagnosis',
    'type1Mellitus',
    'type2Mellitus'
  ]

  toggleSelectDiagnosis({ currentTarget }) {
    this.toggleTargets(this.selectDiagnosisTargets, !currentTarget.checked)
  }

  togglePreselectedE13({ currentTarget }) {
    this.toggleTargets(this.preselectedE13Targets, currentTarget.checked)

    if (!currentTarget.checked) {
      this.clearDefaultOtherTargets()
      this.diabetesDetailsTargets.forEach((element) => {
        this.hideTarget(element)
      })
    }
  }

  toggleDiabetesDetails({ currentTarget, params: { sectionType } }) {
    this.toggleTargets(this.diabetesDetailsTargets, (sectionType !== 'diabetes_type' && currentTarget.checked))
    this.clearOtherDiabetesDetailsTargets(sectionType)
    this.toggleTargets(this.pregnancyDetailsTargets, (sectionType === 'mellitus_pregnancy' && currentTarget.checked))
  }

  toggleGravidityDetails({ currentTarget }) {
    const element = currentTarget

    if (element.value > 0) {
      this.showTarget(this.gravidityDetailsTarget)
    } else {
      this.hideTarget(this.gravidityDetailsTarget)
    }
  }

  clearOtherDiabetesDetailsTargets(sectionType) {
    [
      'mellitusPregnancy',
      'otherMellitus',
      'type1Mellitus',
      'type2Mellitus',
      ...this.nestedDiabetesDetailsTargets
    ].forEach((target) => {
      if (this.nestedDiabetesDetailsTargets.includes(camelCase(sectionType)) && target === 'otherMellitus') return
      if (target !== camelCase(sectionType)) {
        this[`${target}Targets`].forEach((element) => {
          element.checked = false
        })
      }
    })
  }

  clearDefaultOtherTargets() {
    this.defaultOtherTargets.forEach((element) => {
      element.checked = false
    })
  }

  clearDiagnosedDateTargets() {
    this.diagnosedDateTargets.forEach((element) => {
      element.value = ''
    })
  }

  get nestedDiabetesDetailsTargets() {
    return [
      'diabetesGeneticDefectsAndSyndromes',
      'lada',
      'mody',
      'neonatalDiabetes',
      'secondaryDiabetes'
    ]
  }

}
